// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BlogDetailModal_modal__MRWFg .modal-content {
  max-height: 80vh;
}
.BlogDetailModal_header__16GNe {
  padding: 50px 50px 0px 50px;
  background-color: var(--white-color) !important;
  border: none;
}
.BlogDetailModal_heading__ywUWU {
  color: var(--black-dark-text-color) !important;
}

.BlogDetailModal_cardContainer__YdvJd {
  width: 100%;
  background-color: var(--white-color);
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  height: auto;
  position: relative;
  overflow: hidden;
}

.BlogDetailModal_imageContainer__n5\\+S6 {
  height: 234px;
  border-radius: 10px;
  overflow: hidden;
}

.BlogDetailModal_imageContainer__n5\\+S6 img {
  object-fit: cover;
  width: 100%;
  height: 100%;
}

.BlogDetailModal_contentContainer__gABOp {
  padding-top: 20px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.BlogDetailModal_detail__6SL7y {
  color: var(--para-text);
  min-height: 85px;
}
`, "",{"version":3,"sources":["webpack://./src/Components/molecules/BlogDetailModal/BlogDetailModal.module.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;AAClB;AACA;EACE,2BAA2B;EAC3B,+CAA+C;EAC/C,YAAY;AACd;AACA;EACE,8CAA8C;AAChD;;AAEA;EACE,WAAW;EACX,oCAAoC;EACpC,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;AAClB","sourcesContent":[".modal :global(.modal-content) {\n  max-height: 80vh;\n}\n.header {\n  padding: 50px 50px 0px 50px;\n  background-color: var(--white-color) !important;\n  border: none;\n}\n.heading {\n  color: var(--black-dark-text-color) !important;\n}\n\n.cardContainer {\n  width: 100%;\n  background-color: var(--white-color);\n  border-radius: 8px;\n  display: flex;\n  flex-direction: column;\n  height: auto;\n  position: relative;\n  overflow: hidden;\n}\n\n.imageContainer {\n  height: 234px;\n  border-radius: 10px;\n  overflow: hidden;\n}\n\n.imageContainer img {\n  object-fit: cover;\n  width: 100%;\n  height: 100%;\n}\n\n.contentContainer {\n  padding-top: 20px;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.detail {\n  color: var(--para-text);\n  min-height: 85px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modal": `BlogDetailModal_modal__MRWFg`,
	"header": `BlogDetailModal_header__16GNe`,
	"heading": `BlogDetailModal_heading__ywUWU`,
	"cardContainer": `BlogDetailModal_cardContainer__YdvJd`,
	"imageContainer": `BlogDetailModal_imageContainer__n5+S6`,
	"contentContainer": `BlogDetailModal_contentContainer__gABOp`,
	"detail": `BlogDetailModal_detail__6SL7y`
};
export default ___CSS_LOADER_EXPORT___;
